/**
 * src/api/public.ts — UNAUTHENTICATED public endpoints used by the getabeam.com marketing site.
 *
 * Self-serve purchase (WO-D2.2): the marketing pricing page POSTs a buyer email and gets a Stripe
 * Checkout (subscription) URL to redirect to. No session exists yet — the buyer has no account.
 * Provisioning happens later from the verified Stripe webhook (backend publicCheckoutRouter).
 *
 * Uses the shared `post` helper, which simply omits the Authorization header when there is no
 * session token — so these calls work for anonymous visitors.
 *
 * NEVER imports @smartbox/* (mobile invariant 1).
 */
import { post } from './client';
import type { BillingInterval } from '../marketing/content';

export interface CheckoutResponse {
  url: string;
}

/**
 * POST /api/public/checkout { email, interval } → { url }. Throws ApiRequestError on 4xx/5xx.
 * `interval` selects the recurring Stripe price the backend subscribes to ('month' | 'year');
 * the client never sends a raw price id. Defaults to monthly for older callers.
 */
export async function startCheckout(email: string, interval: BillingInterval = 'month'): Promise<CheckoutResponse> {
  return post<CheckoutResponse>('/api/public/checkout', { email: email.trim().toLowerCase(), interval });
}
